export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const MATRIX_UPDATE_CHUNK_SIZE = 500;

export const DRAGGING_BOX_THRESHOLD = 300; // maximum number of selected instances to show the dragging box

export const DRAG_START_THRESHOLD = 5; // distance of pressed pointer movement in pixels to trigger drag start

export const SNAP_THROTTLE_MS = 16; // ~1 frame at 60 fps

export const LOD_DISTANCE_THRESHOLDS_SQ = [9,900] as const;

export const ASSET_REFERENCE_BASE_URL = 'https://azwestprodesdcdnapps.z6.web.core.windows.net/resources/prod/3d/assets_compressed';

export const FRUSTUM_VIEWER_RELATIVE_PATH = '/frustum-viewer';

export const PRIMARY_COLOR_ACCENT_HEX = '#004588';

export const EPSILON = 1e-6;

export const DIMENSION_COLOR = '#35383e';

export const MAIN_DIV_ID = 'maincanvas';
